const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Whether the value is a usable preset id.
 *
 * Presets are named by a uuid, and by nothing else. The seed carried the row
 * numbers of the pre-atom database for a while ("2", "410"), which meant a
 * preset id named one template here and a different one in the next
 * environment; a bare number is now refused wherever presets enter or leave
 * the system, so that cannot come back.
 */
export function isPresetId(value: unknown): value is string {
  return typeof value === "string" && UUID_RE.test(value);
}
